import { create } from 'zustand';
import { IInstanceConfig } from 'src/shared/types/Common';
import { ImmigrationInstance } from 'src/utils/constants/common';

interface ImmigrationInstanceState {
  immigrationInstance: ImmigrationInstance | undefined;
  setImmigrationInstance: (instanceConfig: IInstanceConfig) => void;
}

export const useImmigrationInstanceStore = create<ImmigrationInstanceState>((set) => ({
  immigrationInstance: undefined,

  setImmigrationInstance: (instanceConfig: IInstanceConfig) => {
    const immigrationInstanceId = instanceConfig.immigrationInstance;
    // 1 = Cobalt B, 2 = Cobalt D (Deloitte instance)
    set({ immigrationInstance: immigrationInstanceId === 1 ? ImmigrationInstance.BAL : ImmigrationInstance.DELOITTE });
  },
}));
